const o = {
  beaconTagName: "beacon-chart-tooltip",
  beaconNestedComponents: ["beacon-chart-tooltip-data"]
};
export {
  o
};
